import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { T } from 'Actions/translate';

class TableWrapper extends Component {
  state = {

  }

  render() {
    const { skuReplenishmentDetailList, tableThContent } = this.props;
    
    return (
      <div className='table-div-area'>
        <Paper className='table-paper-area' >
          <Table className='table-area'>
            <TableHead>
              <TableRow>
                  { typeof (tableThContent) !== 'undefined' && tableThContent.map(th => (
                    <TableCell>{ T(th) }</TableCell>
                  )) }
              </TableRow>
            </TableHead>
            <TableBody>
              { typeof (skuReplenishmentDetailList) !== 'undefined' && skuReplenishmentDetailList.map(row => (
                <TableRow>
                  <TableCell>
                    {row.skuList[0].shipmentQuantity}
                  </TableCell>
                  <TableCell>{row.skuList[0].receivedTime}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}


export default TableWrapper
